import {Heading} from '@primer/react'
import type {CommitGroup as CommitGroupType} from '../../types/commits-types'
import {CommitGroup} from './CommitGroup'
import {EndOfFile, RenamedToHistory} from './FileHistory'
import {DeferredCommitDataProvider} from '../../contexts/DeferredCommitDataContext'
import {useLoadDeferredCommitData} from '../../hooks/use-load-deferred-commit-data'

export function CommitList({
  commitGroups,
  deferredDataUrl,
}: {
  commitGroups: CommitGroupType[]
  deferredDataUrl: string
}) {
  const deferredCommitData = useLoadDeferredCommitData(deferredDataUrl)

  return (
    <div className="mb-3" data-hpc>
      <Heading as="h2" className="sr-only">
        Commit History
      </Heading>

      <DeferredCommitDataProvider deferredData={deferredCommitData}>
        <RenamedToHistory />

        {commitGroups.map((commitGroup, index) => {
          return (
            <CommitGroup
              key={commitGroup.title}
              title={commitGroup.title}
              commits={commitGroup.commits}
              isFirstGroup={index === 0}
            />
          )
        })}

        <EndOfFile />
      </DeferredCommitDataProvider>
    </div>
  )
}

try{ CommitList.displayName ||= 'CommitList' } catch {}